import { ScreenshotData } from '@dev/ee-api/ee-api-models';
import { EditorSaveModule } from '@dev/template-editor';
import { useDispatch } from 'react-redux';
import { AvailableFeaturesUpselling } from '@dev/ee-modules';
import { PrebuildModulesAddStart, PrebuildModulesDeleteStart, PrebuildModulesEditStart } from '@/store/prebuildModules/actions';
import { OpenUpsellingOverlay } from '@/store/templateEditor/actions';

export const useModules = () => {
    const dispatch = useDispatch();

    const onModuleAdd = ({ id: Id, title: Name, screenshot, data }: EditorSaveModule) => {
        const screenshotData: ScreenshotData = {
            Base64Image: screenshot.url,
            Width: screenshot.width,
            Height: screenshot.height,
        };
        dispatch(
            PrebuildModulesAddStart({
                Id,
                Name,
                Screenshot: screenshotData,
                Data: Buffer.from(JSON.stringify(data)).toString('base64'),
            })
        );
    };
    const onModuleDelete = (id: string) => {
        dispatch(PrebuildModulesDeleteStart(id));
    };
    const onModuleNameEdit = (id: string, title: string) => {
        dispatch(PrebuildModulesEditStart(id, title));
    };
    const onModuleAddLocked = (): void => {
        dispatch(OpenUpsellingOverlay(AvailableFeaturesUpselling.SavedModules));
    };
    const openModulesUpsellingOverlay = (): void => {
        dispatch(OpenUpsellingOverlay(AvailableFeaturesUpselling.SavedModules));
    };
    const openModulesRecaptchaUpsellingOverlay = (): void => {
        dispatch(OpenUpsellingOverlay(AvailableFeaturesUpselling.Recaptcha));
    };

    return {
        onModuleAdd,
        onModuleDelete,
        onModuleNameEdit,
        onModuleAddLocked,
        openModulesUpsellingOverlay,
        openModulesRecaptchaUpsellingOverlay
    };
};
